import { z } from "zod"
import { ContainerOptionsV1 } from "../containerOptions"

// Version 1 ---------------------
export const RatingSettingsV1 = z.object({
  showCaption: z.union([z.literal(true), z.literal(false)]),
  captionText: z.string(),
})

export type TRatingSettingsV1 = z.infer<typeof RatingSettingsV1>

export const RatingElementV1 = z.object({
  id: z.string(),
  name: z.literal("rating"),
  settings: RatingSettingsV1,
  container: ContainerOptionsV1,
  stars: z.number().int(),
})

export type TRatingElementV1 = z.infer<typeof RatingElementV1>

// Latest ---------------------
export const RatingSettings = RatingSettingsV1
export type TRatingSettings = TRatingSettingsV1
export const RatingElement = RatingElementV1
export type TRatingElement = TRatingElementV1
